import {Component} from 'react'
import './index.css'

class RegistrationForm extends Component {
  state = {
    errorFirst: '',
    errorLast: '',
    firstName: '',
    lastName: '',
    onSuccess: false,
  }

  onSubmitForm = event => {
    const {firstName, lastName} = this.state
    event.preventDefault()
    if (firstName === '') {
      this.setState({errorFirst: 'Required'})
    }
    if (lastName === '') {
      this.setState({errorLast: 'Required'})
    }
    if (firstName !== '' && lastName !== '') {
      this.setState({errorFirst: '', errorLast: '', onSuccess: true})
    }
  }

  newResponse = () => {
    this.setState({onSuccess: false, firstName: '', lastName: ''})
  }

  eventHandlerFirstName = event => {
    if (event.target.value === '') {
      this.setState({errorFirst: 'Required'})
    } else {
      this.setState({errorFirst: '', firstName: event.target.value})
    }
  }

  eventHandlerLastName = event => {
    if (event.target.value === '') {
      this.setState({errorLast: 'Required'})
    } else {
      this.setState({errorLast: '', lastName: event.target.value})
    }
  }

  renderSuccessScreen = () => (
    <div className="on-success">
      <img
        src="https://assets.ccbp.in/frontend/react-js/success-icon-img.png"
        alt="success"
      />
      <p>Submitted Successfully</p>
      <button className="btn" type="submit" onClick={this.newResponse}>
        Submit Another Response
      </button>
    </div>
  )

  renderLoginForm = () => {
    const {errorFirst, errorLast} = this.state
    return (
      <form onSubmit={this.onSubmitForm} className="form-container">
        <div>
          <label className="label-element" htmlFor="first-name">
            FIRST NAME
          </label>{' '}
          <br />
          <input
            onBlur={this.eventHandlerFirstName}
            className={`input-element ${errorFirst}`}
            placeholder="First Name"
            id="first-name"
          />{' '}
          {errorFirst !== '' ? (
            <p className="error-text">{errorFirst}</p>
          ) : null}
        </div>
        <br />
        <div>
          <label className="label-element" htmlFor="last-name">
            LAST NAME
          </label>{' '}
          <br />
          <input
            onBlur={this.eventHandlerLastName}
            className={`input-element ${errorLast}`}
            placeholder="Last Name"
            id="last-name"
          />{' '}
          {errorLast !== '' ? <p className="error-text">{errorLast}</p> : null}
        </div>
        <br />
        <button className="btn" type="submit">
          Submit
        </button>
      </form>
    )
  }

  render() {
    const {onSuccess} = this.state
    return (
      <div className="main-container">
        <h1 className="registration-text">Registration</h1>
        {onSuccess ? this.renderSuccessScreen() : this.renderLoginForm()}
      </div>
    )
  }
}
export default RegistrationForm
